module.exports = __webpack_public_path__ + "img/brand.56b86672.svg";